// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import { Button } from '../../../Buttons.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  initMusculoskeletal: Object,
  resetRomRadios: Function,
  resetPostOperativeRadios: Function,
  resetPostoperativeExtremityRadios: Function,
  resetMovementRadios: Function,
}

class EditMusculoskeletal extends Component<Props> {
  render() {
    const musculoskeletal = this.props.initMusculoskeletal || {};
    return (
      <ContentBox title='Musculoskeletal'>
        <div className={styles.col}>
          <PrimaryText>Range of Motion (ROM)</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox field='musculoskeletal.fullROM' initialValue={musculoskeletal.fullROM} />Moves all extremities with full range of motion<br />
          </div>
          <div className={styles.section}>
            <Button onClick={this.props.resetRomRadios}>Clear Radios</Button>
            <br />
            <SecondaryText>Left arm:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.leftArmROM' initialValue={musculoskeletal.leftArmROM}>
              <Radio value='full rom' />Full ROM<br />
              <Radio value='limited rom' />Limited ROM<br />
              <Radio value='immobile' />Immobile<br />
              <Radio value='flaccid' />Flaccid<br />
              <Radio value='contractured' />Contractured
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right arm:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.rightArmROM' initialValue={musculoskeletal.rightArmROM}>
              <Radio value='full rom' />Full ROM<br />
              <Radio value='limited rom' />Limited ROM<br />
              <Radio value='immobile' />Immobile<br />
              <Radio value='flaccid' />Flaccid<br />
              <Radio value='contractured' />Contractured
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Left leg:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.leftLegROM' initialValue={musculoskeletal.leftLegROM}>
              <Radio value='full rom' />Full ROM<br />
              <Radio value='limited rom' />Limited ROM<br />
              <Radio value='immobile' />Immobile<br />
              <Radio value='flaccid' />Flaccid<br />
              <Radio value='contractured' />Contractured
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right leg:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.rightLegROM' initialValue={musculoskeletal.rightLegROM}>
              <Radio value='full rom' />Full ROM<br />
              <Radio value='limited rom' />Limited ROM<br />
              <Radio value='immobile' />Immobile<br />
              <Radio value='flaccid' />Flaccid<br />
              <Radio value='contractured' />Contractured
            </RadioGroup>
          </div>
          <PrimaryText>Gait/Balance</PrimaryText><br />
          <div className={styles.section}>
            <RadioGroup field='musculoskeletal.gaitBalance' initialValue={musculoskeletal.gaitBalance}>
              <Radio value='steady' />Ambulates on own, steady gait<br />
              <Radio value='unsteady' />Ambulates on own, unsteady gait<br />
              <Radio value='cane' />Ambulates with assistance, cane<br />
              <Radio value='walker' />Ambulates with assistance, walker<br />
              <Radio value='walkerWheelchair' />Walker and wheelchair<br />
              <Radio value='wheelchair' />Wheelchair only<br />
              <Radio value='bedfast' />Bedfast
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>ROM and gait notes:</SecondaryText><br />
            <TextArea field='musculoskeletal.gaitNotes' initialValue={musculoskeletal.gaitNotes} />
          </div>
          <PrimaryText>Amputation</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox field='musculoskeletal.amputee' initialValue={musculoskeletal.amputee} />Amputee
          </div>
          <div className={styles.section}>
            <SecondaryText>Describe amputation:</SecondaryText><br />
            <TextArea field='musculoskeletal.amputationNotes' initialValue={musculoskeletal.amputationNotes} />
          </div>
          <PrimaryText>Postoperative, Orthopedic</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox field='musculoskeletal.postOrthopedic' initialValue={musculoskeletal.postOrthopedic} />Patient is post-orthopedic surgery
          </div>
          <PrimaryText>Post Operative Area</PrimaryText><br />
          <Button onClick={this.props.resetPostOperativeRadios}>Clear Radios</Button>
          <div className={styles.section}>
            <SecondaryText>Left:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpLeft' initialValue={musculoskeletal.postOpLeft}>
              <Radio value='foot' />Foot<br />
              <Radio value='ankle' />Ankle<br />
              <Radio value='knee' />Knee<br />
              <Radio value='hip' />Hip<br />
              <Radio value='wrist' />Wrist<br />
              <Radio value='elbow' />Elbow<br />
              <Radio value='shoulder' />Shoulder<br />
              <Radio value='femur' />Femur<br />
              <Radio value='humerus' />Humerus<br />
              <Radio value='tibia' />Tibia<br />
              <Radio value='fibula' />Fibula
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpRight' initialValue={musculoskeletal.postOpRight}>
              <Radio value='foot' />Foot<br />
              <Radio value='ankle' />Ankle<br />
              <Radio value='knee' />Knee<br />
              <Radio value='hip' />Hip<br />
              <Radio value='wrist' />Wrist<br />
              <Radio value='elbow' />Elbow<br />
              <Radio value='shoulder' />Shoulder<br />
              <Radio value='femur' />Femur<br />
              <Radio value='humerus' />Humerus<br />
              <Radio value='tibia' />Tibia<br />
              <Radio value='fibula' />Fibula
            </RadioGroup>
          </div>
          <PrimaryText>Postoperative Extremity Assessment</PrimaryText><br />
          <Button onClick={this.props.resetPostoperativeExtremityRadios}>Clear Radios</Button>
          <div className={styles.section}>
            <SecondaryText>Temperature:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpTemp' initialValue={musculoskeletal.postOpTemp}>
              <Radio value='warm' />Warm to touch<br />
              <Radio value='cool' />Cool to touch
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Color:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpColor' initialValue={musculoskeletal.postOpColor}>
              <Radio value='expected' />Expected color<br />
              <Radio value='cyanotic' />Cyanotic<br />
              <Radio value='mottled' />Mottled<br />
              <Radio value='reddened' />Reddened
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Capillary refill:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpRefill' initialValue={musculoskeletal.postOpRefill}>
              <Radio value='brisk' />Brisk<br />
              <Radio value='sluggish' />Sluggish
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Sensation:</SecondaryText><br />
            <RadioGroup field='musculoskeletal.postOpSense' initialValue={musculoskeletal.postOpSense}>
              <Radio value='sensation' />Sensation to touch intact<br />
              <Radio value='numb' />Numb and tingling to touch<br />
              <Radio value='none' />No sensation to touch
            </RadioGroup>
          </div>
          <PrimaryText>Movement Evaluation of Affected Limb</PrimaryText><br />
          <Button onClick={this.props.resetMovementRadios}>Clear Radios</Button>
          <div className={styles.section}>
            <SecondaryText>Able to move fingers?</SecondaryText><br />
            <RadioGroup field='musculoskeletal.moveFingers' initialValue={musculoskeletal.moveFingers}>
              <Radio value='yes' />Yes<br />
              <Radio value='no' />No
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Able to move toes?</SecondaryText><br />
            <RadioGroup field='musculoskeletal.moveToes' initialValue={musculoskeletal.moveToes}>
              <Radio value='yes' />Yes<br />
              <Radio value='no' />No
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>General postoperative notes:</SecondaryText><br />
            <TextArea field='musculoskeletal.genPostOpNotes' initialValue={musculoskeletal.genPostOpNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default EditMusculoskeletal;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditMusculoskeletal.jsx